import React, { useState } from 'react';
import { Personal } from '../../../_common/personal';

export const Step2 = ({ personalDataRequirements, setPersonalDataRequirements }) => {
    const [selectedGender, setSelectedGender] = useState(undefined);

    return (
        <article className="view-calc mb-auto">
            <div className="container-fluid">
                {
                    selectedGender === undefined ?
                        <header className="rounded-bottom-left-sm rounded-top-right-sm mb-0 alert alert-primary text-center">
                            <h1 className="text-primary font-weight-bolder mt-2 mb-3">Bienvenue !</h1>
                            <h2 className="text-body ls-0 mt-n2 o-50">Personnalisez cette expérience</h2>
                        </header> :
                        <header className="rounded-bottom-left-sm rounded-top-right-sm mb-0">
                            <h1 className="text-primary font-weight-bolder mt-2 mb-3">Données Personnelles</h1>
                            <h2 className="text-body ls-0 mt-n2 o-50">Aidez-nous à mieux vous connaître.</h2>
                        </header>}
            </div>
            <Personal personalDataRequirements={personalDataRequirements} setPersonalDataRequirements={setPersonalDataRequirements} setSelectedGender={setSelectedGender}/>
        </article>
    )
}